import {useAction, useNavigate} from "@solidjs/router";
import {createForm, FormError, setResponse, SubmitHandler, valiForm} from "@modular-forms/solid";
import * as v from "valibot";
import {createCheckout} from "~/sdk/checkout";
import {Checkout} from "@gs-yoga/sdk/types";
import {ButtonGroup, FormResponse} from "~/components/form/ui/form";
import {Button} from "../ui/Button";

const BuyNowSchema = v.object({
    // bundle: v.boolean()
})

type BuyNowForm = v.InferInput<typeof BuyNowSchema>

export default function BuyNowForm() {

    const [form, MForm] = createForm<BuyNowForm>({
        validate: valiForm(BuyNowSchema)
    })

    const createCheckoutAction = useAction(createCheckout)
    const navigate = useNavigate()

    const handleSubmit: SubmitHandler<BuyNowForm> = async (values, event) => {
        setResponse(form, {status: "info", message: "Processing..."})
        let checkout: Checkout
        try {
            checkout = await createCheckoutAction({
                bundle: false,
                returnUrl: "https://gracefulspaceyoga.com/checkout/success",
                memberId: undefined
            })
        } catch (e) {
            throw new FormError(String(e))
        }
        setResponse(form, {status: "success", message: "Success!"})
        navigate(`/checkout/${checkout.id}`)
    }


    return (
        <MForm.Form onSubmit={handleSubmit}>
            {/*<MForm.Field name="bundle" type="boolean">*/}
            {/*    {(field, props) => (*/}
            {/*        <ZagSwitch name="bundle" checked={field.value}*/}
            {/*                   onCheckedChange={d => setValue(form, "bundle", d.checked)}>*/}
            {/*            {(api) => {*/}
            {/*                return (*/}
            {/*                    <label {...api.getRootProps()}>*/}
            {/*                        <input {...api.getHiddenInputProps()}/>*/}
            {/*                        <span {...api.getControlProps()}>*/}
            {/*                    <span {...api.getThumbProps()}/>*/}
            {/*                </span>*/}
            {/*                        <span {...api.getLabelProps()}>{api.checked ? "Class Pass Bundle (x4)" : "Class Pass"}</span>*/}
            {/*                    </label>*/}
            {/*                )*/}
            {/*            }}*/}
            {/*        </ZagSwitch>*/}
            {/*    )}*/}
            {/*</MForm.Field>*/}
            <p>Price: £10</p>
            <FormResponse response={form.response}/>
            <ButtonGroup>
                <Button type="submit" variant="primarySolid">Buy Now</Button>
            </ButtonGroup>
        </MForm.Form>
    )

}